export default __webpack_public_path__ + "static/media/Adjourning_working_Structure.f7a2a0c5.jpeg";